import * as angular from 'angular';

import { AugmentedEntry, ComponentDefinition } from '../../../models';

class LogbookTableCellController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    readonly entry: AugmentedEntry;
    readonly clickCell: (entry: { entry: AugmentedEntry; $event: angular.IAngularEvent }) => void;

    static $inject = [];

    openModal(entry: AugmentedEntry, $event: angular.IAngularEvent) {
        if (this.clickCell) {
            this.clickCell({ entry: entry, $event: $event });
        }
    }
}

export const wtLogbookTableCell: ComponentDefinition = {
    componentId: 'wtLogbookTableCell',
    controller: LogbookTableCellController,
    template: require('./logbookTableCell.component.html'),
    controllerAs: 'vm',
    transclude: true,
    bindings: {
        entry: '<',
        clickCell: '&'
    }
};